export default function initPasswordToggle() {
  document.querySelectorAll('[data-toggle="password"]').forEach(input => {
    // รองรับ 2 กรณี:
    // 1. input อยู่ใน .input-group โดยตรง (เช่น password_login.html)
    // 2. input อยู่ใน .form-floating ที่ซ้อนอยู่ใน .input-group (เช่น change_password.php)
    const container = input.closest('.input-group') || input.parentElement;
    const toggle = container.querySelector('.input-group-text');
    if (!toggle) return;

    toggle.style.cursor = "pointer";
    toggle.classList.add("input-password-hide");

    toggle.addEventListener("click", () => {
      const icon = toggle.querySelector(".fa");

      if (toggle.classList.contains("input-password-hide")) {
        toggle.classList.replace("input-password-hide", "input-password-show");
        if (icon) icon.classList.replace("fa-eye", "fa-eye-slash");
        input.type = "text";
      } else {
        toggle.classList.replace("input-password-show", "input-password-hide");
        if (icon) icon.classList.replace("fa-eye-slash", "fa-eye");
        input.type = "password";
      }
    });
  });
}
